type TabCounterProps = {
  count: number;
};

export const TabCounter = ({ count }: TabCounterProps) => {
  return (
    <div className="h-4 w-4 min-w-max rounded-full bg-muted p-0.5 text-center">
      <p className="text-[9px] leading-3 tracking-tight text-black">{count}</p>
    </div>
  );
};
